import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const METRIKA_ID = 106602399;

function injectMetrikaScript() {
    if (typeof window === 'undefined') return;

    const src = `https://mc.yandex.ru/metrika/tag.js?id=${METRIKA_ID}`;

    // Проверяем, не подключен ли уже скрипт
    const existing = Array.from(document.scripts).find((s) => s.src === src);
    if (existing) {
        return;
    }

    (function (m, e, t, r, i, k, a) {
        m[i] =
            m[i] ||
            function () {
                (m[i].a = m[i].a || []).push(arguments);
            };
        m[i].l = 1 * new Date();
        k = e.createElement(t);
        a = e.getElementsByTagName(t)[0];
        k.async = 1;
        k.src = r;
        a.parentNode.insertBefore(k, a);
    })(window, document, 'script', src, 'ym');
}

const YandexMetrika = () => {
    const location = useLocation();

    useEffect(() => {
        if (typeof window === 'undefined') return;

        // Не инициализируем Метрику в админ-панели и её подпутях
        if (location.pathname.startsWith('/admin')) {
            return;
        }

        injectMetrikaScript();

        // Инициализация счётчика один раз
        if (typeof window.ym === 'function' && !window.__ymInitialized) {
            window.ym(METRIKA_ID, 'init', {
                ssr: true,
                webvisor: true,
                clickmap: true,
                ecommerce: 'dataLayer',
                referrer: document.referrer,
                url: window.location.href,
                accurateTrackBounce: true,
                trackLinks: true,
            });
            window.__ymInitialized = true;
        }

        // Отправляем hit на каждое изменение маршрута (кроме /admin*)
        if (typeof window.ym === 'function' && window.__ymInitialized) {
            const url = window.location.href;
            try {
                window.ym(METRIKA_ID, 'hit', url);
            } catch (e) {
                // глушим возможные ошибки, чтобы не ломать SPA
                console.warn('Yandex.Metrika hit error:', e.message);
            }
        }
    }, [location.pathname, location.search]);

    return null;
};

export default YandexMetrika;

